import CircularLoading from '@/common/components/base/Loading/CircularLoading';
import PlateShow from '@/common/components/base/plateShow/PlateShow';
import Typography from '@/common/components/base/typography/Typography';
import VehicleInformationIcon from '@/modules/adjusterReportModules/IncidentParticipants/assets/images/vehicle-info.svg?react';
import { InitialVisitVehicleInfoQueryOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/InitialVisitVehicleInfo/InitialVisitVehicleInfoQueryOptions';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { Box, Flex } from 'styled-system/jsx';

const InitialVisitVehicleInformation = () => {
  const { id } = useParams();
  const { data, isPending } = useQuery(
    InitialVisitVehicleInfoQueryOptions({ id: id! }),
  );
  if (isPending)
    return (
      <Flex justify="center" alignItems="center">
        <CircularLoading color="colors.purple-primary" />
      </Flex>
    );
  return (
    <Box boxShadow={'cardShadow'} bgColor="white" p={16} borderRadius="8px">
      <Flex justify="center" alignItems="center" gap={40}>
        {isPending ? (
          <CircularLoading color="colors.purple-primary" />
        ) : (
          <>
            <VehicleInformationIcon />
            <Box
              p={16}
              display="flex"
              flexDirection="column"
              gap={16}
              alignItems="center"
            >
              <Box>
                <Typography>{data?.vehicle_model}</Typography>
              </Box>
              <Box>
                <PlateShow
                  plateData={{
                    vehicle_plate: data?.vehicle_plate,
                    vehicle_plate_bottom: data?.vehicle_plate_bottom,
                    vehicle_plate_iran: data?.vehicle_plate_iran,
                    vehicle_plate_left: data?.vehicle_plate_left,
                    vehicle_plate_letter: data?.vehicle_plate_letter,
                    vehicle_plate_right: data?.vehicle_plate_right,
                    vehicle_plate_top: data?.vehicle_plate_top,
                  }}
                  vehicleDesign={data?.vehicle_plate_design?.const!}
                  vehicleType={data?.vehicle_type?.const!}
                />
              </Box>
            </Box>
          </>
        )}
      </Flex>
    </Box>
  );
};

export default InitialVisitVehicleInformation;
